import { ButtonLink, TabLink } from "@/components/Link";
import IconButtonLink from "@/components/Link/IconButtonLink.tsx";
import AddIcon from "@mui/icons-material/Add";
import { Box, Container, Tabs, Typography } from "@mui/material";
import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";
import { type ReactNode, useMemo } from "react";

const Root = (): ReactNode => {
    const location = useLocation();
    const activeTab = useMemo(
        () => (location.pathname.includes("requests") ? "requests" : "reviews"),
        [location.pathname],
    );

    return (
        <Container>
            <Box sx={{ display: "flex", mb: 2, alignItems: "center" }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                    Review Management
                </Typography>

                <ButtonLink
                    to="/manage/reviews/requests/create"
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{ display: { xs: "none", sm: "flex" } }}
                >
                    Generate Review Links
                </ButtonLink>

                <IconButtonLink
                    to="/manage/reviews/requests/create"
                    sx={{ display: { xs: "flex", sm: "none" } }}
                    edge="end"
                >
                    <AddIcon />
                </IconButtonLink>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                <Tabs value={activeTab}>
                    <TabLink value="reviews" label="Reviews" to="/manage/reviews" />
                    <TabLink value="requests" label="Review Links" to="/manage/reviews/requests" />
                </Tabs>
            </Box>

            <Outlet />
        </Container>
    );
};

export const Route = createFileRoute("/manage/reviews")({
    component: Root,
});
